// extracted by mini-css-extract-plugin
module.exports = {"group":"ProgressionSidebarGroup_group__6Kmnd","items":"ProgressionSidebarGroup_items__UvKlS"};